"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-sls-selective-laser-sintering";

const WHY_CHOOSE_DIR =
	"/image/new-version/more/SLS/Why-Choose-JS-Precision-as-Your-SLS-3D-Printing-Manufacturer";

const CARDS = [
	{
		image: `${WHY_CHOOSE_DIR}/quality-assurance.webp`,
		numberKey: "whyChooseCard1Number",
		titleKey: "whyChooseCard1Title",
		descKey: "whyChooseCard1Desc",
		altKey: "whyChooseCard1Alt",
		bg: "bg-[#000]",
		text: "text-white",
	},
	{
		image: `${WHY_CHOOSE_DIR}/fast-reliable-delivery.webp`,
		numberKey: "whyChooseCard2Number",
		titleKey: "whyChooseCard2Title",
		descKey: "whyChooseCard2Desc",
		altKey: "whyChooseCard2Alt",
		bg: "bg-[#107e03]",
		text: "text-white",
	},
	{
		image: `${WHY_CHOOSE_DIR}/customization-support.webp`,
		numberKey: "whyChooseCard3Number",
		titleKey: "whyChooseCard3Title",
		descKey: "whyChooseCard3Desc",
		altKey: "whyChooseCard3Alt",
		bg: "bg-[#9ec687]",
		text: "text-white",
	},
] as const;

export default function WhyChooseUs() {
	const t = useTranslations(NAMESPACE);
	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("whyChooseTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("whyChooseSubtitle")}</p>
				</header>

				<div className="grid gap-6 md:gap-8 lg:grid-cols-3">
					{CARDS.map((card) => (
						<article
							key={card.numberKey}
							className="group flex flex-col overflow-hidden shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
						>
							<div className="relative aspect-[4/2] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={card.image}
									alt={t(card.altKey)}
									fill
									className="object-cover transition-transform duration-500 group-hover:scale-105"
									sizes="(max-width: 1024px) 100vw, 33vw"
								/>
							</div>
							<div className={`flex flex-1 flex-col px-5 py-6 sm:px-6 sm:py-7 md:px-7 md:py-8 ${card.bg}`}>
								<span className={`mb-3 text-sm font-medium ${card.text} opacity-70`}>
									/{t(card.numberKey)}
								</span>
								<h3 className={`mb-2 text-lg font-bold sm:mb-3 sm:text-xl md:text-2xl ${card.text}`}>
									{t(card.titleKey)}
								</h3>
								<p className={`text-sm leading-relaxed md:text-base ${card.text} opacity-90`}>
									{t(card.descKey)}
								</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
